import { useState, useEffect } from 'react';

export const useWeightInput = (stateWeight: number) => {
  const [weightInput, setWeightInput] = useState<string>(
    stateWeight === 0 ? '' : String(stateWeight),
  );

  useEffect(() => {
    setWeightInput(stateWeight === 0 ? '' : String(stateWeight));
  }, [stateWeight]);

  const commitWeight = (updateState: (updates: { weight: number }) => void) => {
    const parsed = parseFloat(weightInput);
    updateState({ weight: isNaN(parsed) ? 0 : parsed });
  };

  return { weightInput, setWeightInput, commitWeight };
};
